var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleFileThirdIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 7.5,
    stroke: "#CBCBCB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2102_28755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9375 13.1504L32.7871 23L23 32.7871L13.1504 22.9375V13.1504H22.9375ZM15.3496 21.8125L22.8936 29.3564L23 29.4619L23.1064 29.3564L29.3564 23.1064L29.4619 23L29.3564 22.8936L21.8125 15.3496H15.3496V21.8125ZM18.625 16.9004C19.5775 16.9004 20.3496 17.6657 20.3496 18.625C20.3496 19.5775 19.5843 20.3496 18.625 20.3496C17.6725 20.3496 16.9004 19.5843 16.9004 18.625C16.9004 17.6725 17.6657 16.9004 18.625 16.9004Z",
    fill: "#969595",
    stroke: "white",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2102_28755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleFileThirdIcon);
export default __webpack_public_path__ + "static/media/titleFileThirdIcon.8bc552dd79990d99f32af6f1877b39b5.svg";
export { ForwardRef as ReactComponent };